var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6504 22.3504V18.3504H7.15039C6.71706 18.3504 6.35872 18.2087 6.07539 17.9254C5.79206 17.6421 5.65039 17.2837 5.65039 16.8504V6.35039H1.65039V5.65039H5.65039V1.65039H6.35039V16.8504C6.35039 17.0504 6.43372 17.2337 6.60039 17.4004C6.76706 17.5671 6.95039 17.6504 7.15039 17.6504H22.3504V18.3504H18.3504V22.3504H17.6504ZM17.6504 16.9504V7.15039C17.6504 6.95039 17.5671 6.76706 17.4004 6.60039C17.2337 6.43372 17.0504 6.35039 16.8504 6.35039H7.05039V5.65039H16.8504C17.2837 5.65039 17.6421 5.79206 17.9254 6.07539C18.2087 6.35872 18.3504 6.71706 18.3504 7.15039V16.9504H17.6504Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrop);
export default __webpack_public_path__ + "static/media/crop.9abecc448b984fe5380ec6be2bbcf6f6.svg";
export { ForwardRef as ReactComponent };